export interface Leader {
    id: string
    name: string
    role: string
    description: string
    linkedin: string
    image?: string  // Caminho da foto do líder
}

export const leaders: Leader[] = [
    {
        id: 'sandra-estela',
        name: 'Sandra Estela Fábio Fernandes',
        role: 'Líder Executiva de Governança de TI | Transformação Digital & Ágil',
        description: 'Líder Executiva com 35 anos de experiência em TI, especialista em Governança, Gestão de Projetos e Transformação Digital em grandes corporações como BTG Pactual, Bradesco Saúde e Hospital Albert Einstein. Comprovada expertise em estruturar e otimizar áreas de TI, impulsionando a eficiência, conformidade (LGPD) e excelência na entrega de soluções para o setor da Saúde. MBA em Liderança, Inovação e comunicação Executiva pela LEC.',
        linkedin: 'https://www.linkedin.com/in/sandra-estela/',
        image: '/assets/leaders/sandra-estela.jpg',
    },
    {
        id: 'leandro-duque-mussio',
        name: 'Leandro Duque Mussio',
        role: 'Líder em Arquitetura de Soluções | Professor de MBA na FIAP',
        description: 'Especialista em Arquitetura de Soluções com experiência em SRE/DevOps, Observabilidade, Desenvolvimento de Sistemas, Redes e Segurança. Docente de Arquitetura de Microsserviços e Microcontainers no MBA da FIAP. Bacharel em Ciência da Computação, com MBA em Arquitetura de Soluções pela FIAP e Mestrando em Engenharia Elétrica (FEI), na área de Processamento de Sinais e Imagens.',
        linkedin: 'https://www.linkedin.com/in/leandro-duque-mussio/',
        image: '/assets/leaders/leandro-duque-mussio.jpg',
    },
    {
        id: 'fernando-secol',
        name: 'Fernando Mainetti Secol',
        role: 'Líder em Arquitetura de Dados e IA | Professor de MBA na FIAP',
        description: 'Especialista em Arquitetura de Big Data e Machine Learning. Atua na interseção entre tecnologia, dados e inovação, desenhando soluções de Inteligência de Dados para o negócio. Coordenou projetos do PROADI em parceria entre o Hospital Albert Einstein e o Ministério da Saúde. Bacharel em Ciência da Computação e Mestrando em Engenharia Elétrica (FEI), na área de Processamento de Sinais e Imagens.',
        linkedin: 'https://www.linkedin.com/in/fmsecol/',
        image: '/assets/leaders/fernando-secol.jpg',
    },
    {
        id: 'antonio-formoso',
        name: 'Antonio Formoso Jr.',
        role: 'Executivo de TI | Estratégia, Gestão e Governança',
        description: 'Executivo de T.I. e Conselheiro com +40 anos de atuação em Estratégia, Gestão, Governança, Transformação Digital e Organizacional, alinhadas com a Estratégia de Negócios, tendo atuado nos setores Bancário, Seguros, Varejo e Serviços. Graduado em Administração de Empresas pela FAAP e MBA pelo Coppead da UFRJ. Formação de Conselheiro na Board Academy e em AI na PUC-Rio.',
        linkedin: 'https://www.linkedin.com/in/antonio-formoso-jr-2872194/',
        image: '/assets/leaders/antonio-formoso.jpg',
    },
]
